import Helper from "./Helper";

class DynamicChartToggler {
  constructor(config = {}) {
    const {
      container,
      checkbox,
      charts
    } = config;


    this.container = container;
    this.checkbox = checkbox;
    this.charts = charts;

    this.bindEvents();
  }

  bindEvents() {
    this.containers = document.querySelectorAll(this.container);
    this.containers.forEach(c => {
      const buttons = c.querySelectorAll(this.checkbox);
      const charts = c.querySelectorAll(this.charts);

      charts.forEach((chart, index) => {
        chart.dataset.index = index;
      })

      buttons.forEach((button, index) => {
        button.dataset.index = index;

        button.addEventListener('click', (e) => {
          this.buttonActivationHandler(buttons, charts, e);
        });

        if (button.classList.contains('active')) {
          this.buttonActivationHandler(buttons, charts, { target: button, stopPropagation: function () { } });
        }
      });
    });
  }

  buttonActivationHandler(buttons, charts, event) {
    event.stopPropagation();
    buttons.forEach(b => b.classList.remove('active'));
    event.target.closest(this.checkbox).classList.add('active');

    charts.forEach(c => {
      c.classList.remove('active');
      if (c.dataset.index == event.target.closest(this.checkbox).dataset.index) {
        c.classList.add('active');
      }

      if (c.closest(this.container).classList.contains('ns-graphic--animated')) {
        setTimeout(() => {
          c.classList.add('animated');
        }, 200);
      }
    })
  }
}

export default DynamicChartToggler;
